import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { TransferStatusBadge } from '../../atoms/TransferStatusBadge';
import { calculateTransferStatus } from '../../../helpers/transferStatusCalculator';
import { dateFormatter } from '../../../helpers/dataFormatters';
import { LoadingSpinner } from '../../atoms/LoadingSpinner';

function poRefFormatter(cell) {
    return <Link to={`/ps-transfer/${cell}`}>{cell}</Link>;
}

function vendorFormatter(cell) {
    return cell ? cell.name : '';
}

function statusFormatter(cell, row) {
    const status = calculateTransferStatus(row);
    return <TransferStatusBadge status={status} />;
}

function itemCountFormatter(cell) {
    return cell ? cell.length : 0;
}

class PsTransferDashboardTable extends React.Component {
    render() {
        const { purchaseOrders, isLoaded, error } = this.props;

        if (error) {
            return <div className="text-danger">Error loading POs: {error.message}</div>;
        }

        if (!isLoaded) {
            return <LoadingSpinner />;
        }

        if (!purchaseOrders || purchaseOrders.length === 0) {
            return <div className="text-muted">No PiShop POs found.</div>;
        }

        const options = {
            sizePerPage: 15,
            sizePerPageList: [10, 15, 25, 50],
            paginationPosition: 'bottom'
        };

        return (
            <BootstrapTable
                data={purchaseOrders}
                striped
                hover
                pagination
                options={options}
                version="4"
            >
                <TableHeaderColumn
                    isKey
                    dataField="ref"
                    dataSort
                    dataFormat={poRefFormatter}
                    width="15%"
                >
                    PO Ref
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="vendor"
                    dataFormat={vendorFormatter}
                    dataSort
                    width="25%"
                >
                    Vendor
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="purchaseDate"
                    dataFormat={dateFormatter}
                    dataSort
                    width="15%"
                >
                    Date
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="items"
                    dataFormat={itemCountFormatter}
                    width="10%"
                >
                    Items
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="meta"
                    dataFormat={statusFormatter}
                    width="20%"
                >
                    Transfer Status
                </TableHeaderColumn>
            </BootstrapTable>
        );
    }
}

PsTransferDashboardTable.propTypes = {
    purchaseOrders: PropTypes.array,
    isLoaded: PropTypes.bool.isRequired,
    error: PropTypes.object
};

export { PsTransferDashboardTable };
